import { useEffect } from "react";
import { getStripePrices } from "../../api/memberships";
import { formatPrice } from "../../lib/generic";
import { setStripePrices } from "../../redux/stripePricesSlice";
import { useDispatch } from "react-redux";
import useUser from "../user/useUser";
import { setUserFullSubscriptionData } from "../../redux/pages/trainingPlanSlice";
import { PriceFromStripe } from "../../interfaces/apiRequests/PriceFromStripe";

export const useStripePrices = (currentCoachGoldValue?: number | string) => {
  const dispatch = useDispatch();
  const { user } = useUser();

  useEffect(() => {
    getStripePrices()
      .then((data) => {
        const bronzeStripeObject = data.find(
          (element) => element.type === "bronzev2"
        );
        bronzeStripeObject.subscriptionPlanPaymentProviders =
          bronzeStripeObject.subscriptionPlanPaymentProviders.filter(
            (provider) => provider.paymentProvider === "stripe"
          );
        const silverStripeObject = data.find(
          (element) => element.type === "silverv2"
        );
        silverStripeObject.subscriptionPlanPaymentProviders =
          silverStripeObject.subscriptionPlanPaymentProviders.filter(
            (provider) => provider.paymentProvider === "stripe"
          );
        const goldStripeObject = data.find(
          (element) => element.type === "goldv2"
        );
        goldStripeObject.subscriptionPlanPaymentProviders =
          goldStripeObject.subscriptionPlanPaymentProviders.filter(
            (provider) => provider.paymentProvider === "stripe"
          );
        const stripePrices = {
          bronze: bronzeStripeObject ? bronzeStripeObject : null,
          silver: silverStripeObject ? silverStripeObject : null,
          gold: goldStripeObject ? goldStripeObject : null,
          oneToOne: currentCoachGoldValue
            ? formatPrice(currentCoachGoldValue)
            : null,
        };

        if (user.subscription_data?.subscriptionPlan?.title.includes("v2")) {
          const subsWithoutV2 =
            user.subscription_data.subscriptionPlan.title.split("v2")[0];
          dispatch(
            setUserFullSubscriptionData(
              stripePrices[subsWithoutV2] as PriceFromStripe
            )
          );
          dispatch(setStripePrices(stripePrices));

          return;
        }

        if (user.subscription_data?.subscriptionPlan) {
          dispatch(
            setUserFullSubscriptionData(
              stripePrices[
                user.subscription_data.subscriptionPlan.title
              ] as PriceFromStripe
            )
          );
        }

        dispatch(setStripePrices(stripePrices));
      })
      .catch((error: Error) => {
        console.error(error);
      });
  }, [
    currentCoachGoldValue,
    dispatch,
    user?.subscription_data?.subscriptionPlan,
  ]);
};
